import React, {useEffect, useState} from 'react';
import {Button, Form, Grid, Header, Icon, Input, Label, Modal, Pagination, Segment, Table} from 'semantic-ui-react';
import moment from "moment/moment";
import {toast, ToastOptions} from "react-toastify";
import {SessionUser} from "../../models/session-user";
import {useBlockUI} from "../../shared/services/block-ui-service";
import SessionStorage from "../../store/session";
import {ToasterConfig} from "../../config/ToasterConfig";
import {ShortDto} from "../../models/short-dto";
import useDriverService from "../../services/backoffice/hooks/useDriverService";
import {FleetDriverFilters} from "../../filters/fleet-driver-filters";
import useFleetService from "../../services/backoffice/hooks/useFleetService";
import {DriverFleet} from "../../models/requests/driver-fleet";
import {CreateDriverFleetRequest} from "../../models/requests/create-driver-fleet-request";
import {useNavigate} from "react-router-dom";
import TooltipInfo from "../tooltip/tooltip";

interface FleetDriversListProps {
    fleetId: string;
}

const FleetDriversListComponent: React.FC<FleetDriversListProps> = ({fleetId}) => {
    const [motoristas, setMotoristas] = useState<DriverFleet[]>([]);
    const [driverList, setdriverList] = useState<ShortDto[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [filterDriver, setFilterDriver] = useState<FleetDriverFilters>({fleetId: fleetId ?? null});
    const [totalPages, setTotalPages] = useState<number>();
    const [sessionUser, setSessionUser] = useState<SessionUser>();
    const [modalFleetDriver, setModalFleetDriver] = useState<Partial<CreateDriverFleetRequest>>({});
    const [isModalOpen, setIsModalOpen] = useState(false);
    const {getAllFilteredDriversShortDto} = useDriverService();
    const {getFleetDrivers, linkDriverFleet, deleteDriverFleet} = useFleetService()
    const blockUI = useBlockUI();
    const [showFilters, setShowFilters] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        blockUI?.setActive(loading)
    }, [loading]);
    const toggleFilters = () => {
        setShowFilters(!showFilters);
    };

    useEffect(() => {
        async function updateSessionUser() {
            const user = await SessionStorage.getSession();
            setSessionUser(user);
        }
        updateSessionUser();
    }, []);

    useEffect(() => {
        async function listFleetDriversSelect() {
            setLoading(true);
            const response = await getAllFilteredDriversShortDto({FleetId: fleetId, OnlyUnliked: true}).finally(() => setLoading(false));
            setdriverList(response);
        }

        listFleetDriversSelect();
    }, [fleetId]);


    useEffect(() => {
        listMotoristas();
    }, []);




    async function deleteMotorista(motorista: any) {
        try {
            const confirm = window.confirm(`Tem certeza que deseja desfazer a ligação com o motorista ${motorista.driverName}?`);
            if (confirm) {
                await deleteDriverFleet(fleetId, motorista.driverId);
                toast.success('Ligação entre operação e motorista desfeita com sucesso', ToasterConfig.success);
                await listMotoristas();
            }
        } catch (error: any) {
            setLoading(false);
        }
    }

    async function listMotoristas() {
        setLoading(true);
        try {
            const response = await getFleetDrivers(filterDriver);
            setMotoristas(response?.itens);
            setTotalPages(response.totalPages);
        } catch (error) {
        } finally {
            setLoading(false);
        }
    }

    const handleSubmit = async () => {
        try {
            setLoading(true);
            await linkDriverFleet({...modalFleetDriver, fleetId: fleetId})
                .then(() => {
                    toast.success('Motorista vinculado a operação com sucesso', ToasterConfig.success);
                    setIsModalOpen(false);
                    setModalFleetDriver({});
                    listMotoristas();
                })
        } catch (error) {
        } finally {
            setLoading(false);
        }
    };


    return (
        <div>

            <Header as="h3" textAlign="center" color={'green'}>
                Motoristas da Operação: {motoristas.length > 0 && (
                <span style={{color: 'black'}}>
                    {motoristas[0].fleetName}
                </span>
            )}
            </Header>

            <Table.Row>

            <Table.HeaderCell>
                <Button content="Voltar para lista de operações"
                        icon='arrow left'
                        onClick={() =>
                            navigate('/backoffice/fleets')} grey/>
            </Table.HeaderCell>
                {sessionUser?.userData?.profile === 'Admin' && (
                    <Table.HeaderCell>
                        <TooltipInfo
                            content="Clique aqui para adicionar motoristas à operação."
                            trigger={
                                <Button
                                    color="green"
                                    onClick={() => setIsModalOpen(true)}
                                >
                                    <Icon name="plus" /> Adicionar Motoristas
                                </Button>
                            }
                        />
                    </Table.HeaderCell>
                )}

            <Table.HeaderCell colSpan="4">
                <Button onClick={toggleFilters} color={"green"}>
                    <Icon name={showFilters ? 'hide' : 'unhide'}/>
                    {showFilters ? 'Ocultar filtros' : 'Exibir filtros'}
                </Button>
            </Table.HeaderCell>
            </Table.Row>

            {showFilters && (
                <Segment>
                    <Grid stackable doubling padded>
                        <Grid.Row>
                            <Grid.Column width={14}>
                                <label htmlFor="driverName">Nome do motorista</label>
                                <Input
                                    fluid
                                    id="driverName"
                                    icon="search"
                                    type="text"
                                    placeholder="Nome do motorista"
                                    value={filterDriver?.driverName ?? ''}
                                    onChange={event =>
                                        setFilterDriver({...filterDriver, driverName: event.target?.value})
                                    }
                                />
                            </Grid.Column>
                            <Grid.Column width={2} verticalAlign="bottom">
                                <Button color={"green"} onClick={listMotoristas}>Filtrar</Button>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Segment>
            )}

            <Table color={"green"}>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>#</Table.HeaderCell>
                        <Table.HeaderCell>Nome</Table.HeaderCell>
                        <Table.HeaderCell>Adicionado em</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {motoristas?.map((motorista) => (
                        <Table.Row key={motorista.driverId}>
                            <Table.Cell>
                                <Button.Group>
                                    <TooltipInfo
                                        content="Clique para desvincular o motorista da operação."
                                        trigger={
                                            <Button
                                                color="red"
                                                onClick={() => deleteMotorista(motorista)}
                                                icon="broken chain"
                                                content="Desvincular"
                                            />
                                        }
                                    />
                                </Button.Group>
                            </Table.Cell>
                            <Table.Cell>{`${motorista.driverName ?? ''}`}</Table.Cell>
                            <Table.Cell>{moment(motorista.createdAt).format('DD/MM/YY HH:mm')}</Table.Cell>
                        </Table.Row>
                    ))}
                </Table.Body>
            </Table>
            <Pagination
                totalPages={totalPages ?? 0}
                defaultActivePage={filterDriver?.Page ?? 1}
                onPageChange={(e, {activePage}) => {
                    setFilterDriver({...filterDriver, Page: activePage as number});
                }}
            />

            <Modal open={isModalOpen} onClose={() => setIsModalOpen(false)}>
                <Modal.Header>Selecione os motoristas a serem adicionados a operação</Modal.Header>
                <Modal.Content>
                    <Form size="large">
                        <Segment stacked>
                            <Form.Select
                                label="Operação"
                                name="fleetId"
                                placeholder="Selecione um cliente"
                                options={fleetId ? [{key: fleetId, text: fleetId, value: fleetId}] : []}
                                value={modalFleetDriver?.fleetId}
                                onChange={(evento: any, data: any) => {
                                    setModalFleetDriver({
                                        ...modalFleetDriver,
                                        fleetId: data.value,
                                    });
                                }}
                                required
                                disabled
                            />

                            <Form.Select
                                label="Qual motorista a ser adicionado ao cliente?"
                                name="driverId"
                                placeholder="Selecione uma opção"
                                options={driverList}
                                value={modalFleetDriver?.driversIds}
                                onChange={(evento: any, data: any) => {
                                    setModalFleetDriver({
                                        ...modalFleetDriver,
                                        driversIds: data.value,
                                    });
                                }}
                                multiple
                            />

                        </Segment>
                    </Form>
                </Modal.Content>
                <Modal.Actions>
                    <Button color="green" onClick={handleSubmit}>
                        Adicionar
                    </Button>
                    <Button color="red" onClick={() => setIsModalOpen(false)}>
                        Fechar
                    </Button>
                </Modal.Actions>
            </Modal>
        </div>
    );
};

export default FleetDriversListComponent

